<template>
    <div class="user-edit-modal-container absolute inset-0 flex flex-col items-center justify-center" @click="$emit('close')">
        <div
        @click.stop
        class="absolute user-edit-modal bg-white rounded-md shadow-dark z-10 flex flex-col mb-28 mt-4">

            <!-- Modal Header -->
            <div class="user-edit-modal-header relative z-1">
                <p class="uppercase text-xs font-main-bold py-4">
                    Modifier mon profil

                    <!-- Close button -->
                    <img class="w-4 float-right mr-4 cursor-pointer" src="@/assets/images/close-icon.svg"
                    @click="$emit('close')">
                </p>
            </div>

            <!-- Modal content -->
            <form v-if="userInfo && userInfo.id" class="user-edit-modal-content" @submit.prevent="onFormSubmit">
                <div class="inline-block align-top w-1/2 p-4">
                    <label for="firstname">Prénom</label>
                    <input 
                    type="text"
                    id="firstname"
                    class="faa-textfield mb-4" 
                    :disabled="hasPendingRequest"
                    v-model="firstname">

                    <label for="navigation">Type de navigation</label>
                    <v-select
                    class="faa-select mb-1"
                    id="navigation"
                    name="navigation"
                    :disabled="hasPendingRequest"
                    :options="navigationList"
                    :clearable="false"
                    :searchable="false"
                    v-model="navigation"
                    ></v-select>

                    <span class="block text-left text-xs text-gray-dark">
                        Si vous avez été nouvellement nommé, préférez la <u>navigation guidée</u>, si vous êtes experimenté, préférez la <u>navigation libre</u>.
                    </span>
                </div>

                <div class="inline-block align-top w-1/2 p-4">
                    <label for="lastname">Nom</label>
                    <input 
                    type="text"
                    id="lastname"
                    class="faa-textfield mb-10" 
                    :disabled="hasPendingRequest"
                    v-model="lastname">

                    <label class="checkbox" :class="{ disabled: hasPendingRequest }">
                        <input
                        class="faa-checkbox"
                        type="checkbox"
                        name="agreeMailing"
                        :disabled="hasPendingRequest"
                        v-model="agreeMailing">
                        <span>
                            J'accepte de recevoir de l'information de la Fédération des OPH
                        </span>
                    </label>
                </div>

                <p class="font-main-medium mt-2">Changer de mot de passe</p>

                <div class="inline-block align-top w-1/2 p-4 pt-2">
                    <label for="new-password">Nouveau mot de passe</label>
                    <input 
                    type="password"
                    id="new-password"
                    class="faa-textfield mb-4" 
                    :disabled="hasPendingRequest"
                    v-model="newPassword">
                </div>

                <div class="inline-block align-top w-1/2 p-4 pt-2">
                    <label for="new-password-confirm">Confirmation du nouveau mot de passe</label>
                    <input 
                    type="password"
                    id="new-password-confirm"
                    class="faa-textfield mb-4" 
                    :disabled="hasPendingRequest"
                    v-model="newPasswordConfirm">
                </div>

                <button
                type="submit" 
                class="faa-button-blue mx-auto"
                :class="{ 'loading': hasPendingRequest }"
                :disabled="hasPendingRequest">
                    Enregistrer
                    <div class="faa-loader">
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </button>
            </form>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex'

    export default {
        name: 'UserEditModal',
        data() {
            const navigationList = [
                {
                    id: 0,
                    label: 'Guidée',
                },
                {
                    id: 1,
                    label: 'Libre',
                },
            ]

            return {
                // UI state
                hasPendingRequest: false,
                // Data state
                firstname: '',
                lastname: '',
                newPassword: '',
                newPasswordConfirm: '',
                navigation: navigationList[0],
                agreeMailing: false,
                // Data source
                navigationList
            }
        },
        computed: {
            ...mapState('Auth', [ 'userInfo' ]),
        },
        watch: {
            userInfo: {
                handler(userInfo) {
                    if (userInfo) {
                        this.firstname = userInfo.first_name
                        this.lastname = userInfo.name
                        this.navigation = (userInfo.experienced ? this.navigationList[1] : this.navigationList[0])
                        this.agreeMailing = userInfo.mailing
                    }
                },
                immediate: true
            }
        },
        methods: {
            async onFormSubmit() {
                if (this.hasPendingRequest || !this.userInfo.id)
                    return

                this.hasPendingRequest = true

                // Check required fields
                if (this.firstname.trim().length <= 2 || this.lastname.trim().length <= 2) {
                    alert('Les champs nom et prénom sont obligatoires')
                    this.hasPendingRequest = false
                    return
                }

                if (this.newPassword.length > 0 && this.newPassword !== this.newPasswordConfirm) {
                    alert('Le champ de confirmation du nouveau mot de passe est incorrecte')
                    this.hasPendingRequest = false
                    return
                }

                // Update user profil data
                let success = await this.$store.dispatch('Auth/updateUserProfil', {
                    id: this.userInfo.id,
                    experienced: (this.navigation.id == 1),
                    fName: this.firstname,
                    lName: this.lastname,
                    mailing: this.agreeMailing
                })

                if (!success) {
                    alert('Erreur de mise à jour des données')
                    this.hasPendingRequest = false
                    return
                }

                // Update password if needed
                if (this.newPassword.length > 0) {
                    success = await this.$store.dispatch('Auth/updateUserPassword', {
                        newPassword: this.newPassword
                    })

                    if (!success) {
                        alert('Erreur de mise à jour du mot de passe')
                        this.hasPendingRequest = false
                        return
                    }
                }

                this.$emit('close')

                this.hasPendingRequest = false
            }
        }
    }
</script>

<style lang="scss" scoped>

.user-edit-modal {
    width: 800px;
    max-width: 90%;
    max-height: 90%;

    &.media-modal {
        width: auto;
        max-width: 70%;
    }

    &-header {
        box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.1);// todo
    }

    &-content {
        @apply p-4;
        overflow: auto;
        height: 100%;

        & > div {
            @apply text-left;
        }

        label, input[type="text"], input[type="password"], button {
            @apply block appearance-none;

            &:focus {
                @apply outline-none;
            }
        }

        label {
            @apply mb-1;
        }

        .checkbox {
            @apply flex items-center justify-start text-sm cursor-pointer my-1;
            vertical-align: top;
            width: 100%;
            text-align: left;

            span {
                @apply w-full ml-2;
            }

            input {
                @apply mr-3 flex-shrink-0;
            }

            &.disabled span {
                @apply cursor-not-allowed;
                opacity: 0.6;
            }
        }
    }
}

</style>
